import { Button } from '@mantine/core';
import { IconFileDownload } from '@tabler/icons-react';
import { i18nKeys, useTranslation } from 'locales';
import posthog from 'posthog-js';
import { captureEvent } from 'shared/analytics/capture-event';

const LABELS = {
  xlsx: i18nKeys.REPORTS.SHOW.DOWNLOAD_XLSX,
  csv: i18nKeys.REPORTS.SHOW.DOWNLOAD_CSV,
};

type Props = {
  href: string;
  format: keyof typeof LABELS;
};

export const ReportExportDownloadButton = ({ href, format }: Props) => {
  const { t } = useTranslation();

  return (
    <Button
      component="a"
      href={href}
      size="xs"
      variant="light"
      rightSection={<IconFileDownload stroke={1.5} size="1.2rem" />}
      onClick={() => captureEvent(posthog, 'reports:export_downloaded', { format })}
    >
      {t(LABELS[format])}
    </Button>
  );
};
